import { createSelector } from 'reselect'
import productTypes from 'helpers/enums/productTypes'
const getUserData = state => state.user.data

const maxPresentationSizeReachedSelector = createSelector(
	[ getUserData ],
	userState => ({
		maxSizeOfPresentations: userState.maxSizeOfPresentations,
		shouldShowContact: [productTypes.SCHOOL, productTypes.DISTRICT].includes(userState.productId),
	})
)

export default maxPresentationSizeReachedSelector
